import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import {
  DashedLine,
  OverageRateBlock,
} from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/ui/PricingPlanCard/styles';
import { CheckoutCardInfoRow } from '@/bundle/_MasterAdmin/_BillingPage/ui/CheckoutCardInfoRow';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { getBuyOverageWiresPath } from '@/bundle/_MasterAdmin/_BuyOverageWiresPage/path/path';
import { CardDetailsWrapper } from '@/bundle/_MasterAdmin/_BillingPage/ui/styles';
import { BillingPlanType } from '@/api/v1/billing/getBillingPlanDetailsApi';
import { convertCentsToDollars } from '@/helpers/formatHelpers';
import { isSingleUsePaymentPlan } from '@/helpers/billingHelpers';

type SinglePaymentSummaryDetailsType = {
  plan: BillingPlanType;
  wiresQuantity: number;
};

export const SinglePaymentSummaryDetails = ({ plan, wiresQuantity }: SinglePaymentSummaryDetailsType) => {
  const { extra_view_price_amount, schedule_type, name } = plan;

  const overageWirePrice = convertCentsToDollars(extra_view_price_amount);
  const totalOverageWiresPrice = convertCentsToDollars(extra_view_price_amount * wiresQuantity);
  const planName = isSingleUsePaymentPlan(schedule_type) ? name : `${name} Plan`;

  return (
    <CardDetailsWrapper>
      <Box width='100%' display='flex' flexDirection='column' rowGap='16px'>
        <Typography variant='subTitleSmall' fontWeight='semibold' color={COLORS.black}>
          Purchase Summary
        </Typography>
        <DashedLine />
        <OverageRateBlock>
          <Box display='flex' flexDirection='column' rowGap='4px'>
            <CheckoutCardInfoRow title='Current Plan' value={planName} />
            <CheckoutCardInfoRow title='Wires number' value={wiresQuantity} />
            <CheckoutCardInfoRow title='Price per Wire' value={overageWirePrice} />
          </Box>

          <Box marginTop='12px' marginBottom='8px'>
            <DashedLine />
          </Box>

          <CheckoutCardInfoRow title='Total Price' value={totalOverageWiresPrice} variant='summary' />
        </OverageRateBlock>

        <Box display='flex' alignItems='center' justifyContent='center'>
          <NavigationLink to={getBuyOverageWiresPath()}>Change Wires Number</NavigationLink>
        </Box>
      </Box>
    </CardDetailsWrapper>
  );
};
